import aws from '@/helpers/aws'
import axios from '@/helpers/axios'
import storage from '@/helpers/storage'
import { check } from '@/helpers/auth-token'
import router from '@/router'
import { get, capitalize } from 'lodash'
import jwtDecode from 'jwt-decode';

const getters = {
  isAuthenticated(state) {
    return !!state.token && check(state.token)
  },
  userId(state) {
    return get(state, 'user.data.id')
  },
  username(state) {
    const username = get(state, 'user.data.attributes.username') || ''
    return capitalize(username)
  },
  roles(state) {
    try {
       const decodedToken = jwtDecode(state.token)
       return decodedToken['cognito:groups'] || []
    } catch(err) {
      console.error(err)
      return []
    }
  }
}

const state = {
  token: check(storage.get('token')) ? storage.get('token') : null,
  user: check(storage.get('token')) ? storage.get('user') : null,
}

const mutations = {
  setToken(state, payload) {
    state.token = payload
  },
  setUser(state, payload) {
    state.user = payload
  }
}

const actions = {
  signIn({ commit }, payload) {
    commit('app/setLoading', true, { root: true })
    return aws.Auth.signIn(payload.username, payload.password)
      .then((user) => {

        const token = user.signInUserSession.idToken.jwtToken

        storage.set('token', token)
        commit('setToken', token)
      })
      .finally(() => commit('app/setLoading', false, { root: true }))
  },

  signUp(context, { given_name, family_name, password, email, birthdate, username }) {
    return aws.Auth.signUp({
      password,
      username,
      attributes: {
        email,
        given_name,
        family_name,
        birthdate
      }
    })
  },

  changePassword(context, { oldPassword, newPassword }) {
    return aws.Auth.currentAuthenticatedUser().then(user => {
      return aws.Auth.changePassword(user, oldPassword, newPassword)
    })
  },

  async refreshToken({ commit }) {
    const cognitoUser = await aws.Auth.currentAuthenticatedUser();
    const currentSession = await aws.Auth.currentSession();
    cognitoUser.refreshSession(currentSession.refreshToken, async (err, session) => {
      if (err) {
        return console.error(err)
      }
      commit('setToken', session.idToken.jwtToken)
    });
  },

  resendCode(context, { username }) {
    return aws.Auth.resendSignUp(username)
  },

  confirmSignUp(context, { username, code }) {
    return aws.Auth.confirmSignUp(username, code, {
      forceAliasCreation: true
    })
  },

  getUser({ commit }) {
    return axios
      .get(`${process.env.VUE_APP_PIPELINE_API_URL}/users/active/`)
      .then(({ data }) => {
        storage.set('user', data)
        commit('setUser', data)
      })
  },

  signOut({ commit }) {
    storage.remove('token')
    storage.remove('user')
    aws.Auth.signOut()
    storage.set('token', undefined)
    commit('setToken', undefined)
    commit('setUser', undefined)
    router.push('sign-in')
  },

  checkSession({ state, dispatch }) {
    const isTokenValid = check(state.token)
    if (!isTokenValid) { dispatch('signOut') }
    return isTokenValid
  }
}

export default {
  namespaced: true,
  getters,
  state,
  actions,
  mutations
}
